export default class ViewFileCtrl {
  constructor ($scope, $mdDialog, WorkPlanModalSrv) {
  // constants
    const url = WorkPlanModalSrv.getVariable()

    $scope.url = ''

    $scope.close = close

    activate()

    function activate () {
      $scope.url = url
    }

    function close () {
      return $mdDialog.hide()
    }

  }
}

ViewFileCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/modals/viewFileCtrl.js